import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";

export default function Gift({ data }) {
  return (
    <Card sx={{ marginTop: 5, marginBottom: 5 , borderRadius: 10}} variant="outlined">
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
      >
        <img
          src={data.icon}
          alt="itemPic"
          style={{ width: 135, height: 120, borderRadius: 10 }}
        />
      </Stack>
      <CardContent>
        <Typography variant="h5" style={{ textAlign: "center" }}>
          {data.name}
        </Typography>
        <Divider style={{ marginTop: 30 }}>
          <Chip
            label={"INTIMACY : " + data.intimacy}
            color="primary"
            size="medium"
          />
        </Divider>
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            Description :
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {data.description}
          </Typography>
        </CardContent>
      </CardContent>
    </Card>
  );
}
